<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('settings.transaltion.editTranslation') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="product-translation-edit-form" tag="form">
          <div class="form-group">
            <label>
              {{ $t('ui.language') }}:
            </label>

            <d-form-select
              v-model="language"
              :options="languageOptions" />
          </div>

          <div class="form-group">
            <label>
              {{ $t('product.productName') }}:
            </label>

            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="name" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('ui.shortDescription') }}:
            </label>

            <validation-provider
              rules="required"
              name="intro"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="intro" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('product.productDescription') }}:
            </label>

            <validation-provider
              rules="required"
              name="description"
              v-slot="{ errors }">
              <d-textarea
                :state="errors.length ? 'invalid' : null"
                :value.prop="description"
                v-model="description" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('product.siteDescription') }}:
            </label>

            <d-textarea
              :value.prop="site_description"
              v-model="site_description" />
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('product.descriptionForCustomer') }}:
            </label>

            <d-textarea
              :value.prop="description_for_customer"
              v-model="description_for_customer" />
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('product.linkToWWWPage') }}:
            </label>

            <validation-provider
              rules="valid-url"
              name="site-url"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="site_url" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('product.linkToDropbox') }}:
            </label>

            <validation-provider
              rules="valid-url"
              name="dropbox-url"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="dropbox_url" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        {{ $t('ui.saveChanges') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'product-translation-edit-popup',
  props: {
    productID: {
      default: 0,
      type: Number
    },
    translationData: {
      default: () => ({}),
      type: Object
    },
    languages: {
      default: () => ([]),
      type: Array
    }
  },
  computed: {
    languageOptions () {
      return this.languages.filter(language => language.id > 1).map(language => ({
        value: language.id,
        text: language.name
      }));
    }
  },
  data () {
    return {
      language: this.translationData.language_id,
      translationID: this.translationData.id,
      name: this.translationData.name,
      intro: this.translationData.intro,
      description: this.translationData.description,
      site_description: this.translationData.site_description,
      description_for_customer: this.translationData.description_for_customer,
      site_url: this.translationData.site_url,
      dropbox_url: this.translationData.dropbox_url
    };
  },
  methods: {
    handleClose (translationID) {
      this.$bus.$emit('product-translation-edit-popup-close', translationID);
    },
    validateForm () {
      FormUtils.validate(this.$refs['product-translation-edit-form'], this.saveTranslation);
    },
    saveTranslation () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/products/translations/update/' + this.translationID,
        formData: {
          product_id: this.productID,
          language_id: this.language,
          name: this.name,
          intro: this.intro,
          description: this.description,
          site_description: this.site_description,
          description_for_customer: this.description_for_customer,
          site_url: this.site_url,
          dropbox_url: this.dropbox_url
        },
        successTitle: this.$t('settings.transaltion.translationEditSuccessTitle'),
        successText: this.$t('settings.transaltion.translationEditSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.transaltion.translationEditErrorText'),
        successAction: res => {
          this.$bus.$emit('product-reload-translations');
          this.handleClose(res.id);
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
